import { render, staticRenderFns } from "./WidgetNewsList.vue?vue&type=template&id=3f839a64&scoped=true"
import script from "./WidgetNewsList.vue?vue&type=script&lang=js"
export * from "./WidgetNewsList.vue?vue&type=script&lang=js"
import style0 from "./WidgetNewsList.vue?vue&type=style&index=0&id=3f839a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f839a64",
  null
  
)

export default component.exports